module.exports = __webpack_public_path__ + "img/done.d09ced80.svg";